import { render } from "./NewsletterSubscriptionBanner.vue?vue&type=template&id=5878213e"
import script from "./NewsletterSubscriptionBanner.vue?vue&type=script&lang=js"
export * from "./NewsletterSubscriptionBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__